<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
  <p style="font-size: 20px; color: white">Carregando...</p>
</ngx-spinner>
<ngx-spinner bdColor="rgba(51,51,51,0.8)" name="comissao" size="medium" color="#fff" type="ball-scale-multiple">
  <p style="font-size: 20px; color: white">Carregando...</p>
</ngx-spinner>

<app-pesquisar-matricula
  *ngIf="matricula == null"
  [titulo]="'Comissão'"
  [inputText]="true"
  (colaboradorEmitter)="matriculaListener($event)"
></app-pesquisar-matricula>

<section class="container" *ngIf="matricula != null">
  <div class="card">
    <div class="card-header">
      <h3 class="card-title font-weight-semibold">
        <i
          class="fa fa-arrow-left pr-3 btn"
          aria-hidden="true"
          (click)="retornarTelaInicial()"
          style="cursor: pointer; bottom: 2px"
        ></i
        >Comissão
      </h3>
    </div>
    <div class="card-body">
      <form #colaborador="ngForm" class="row" [formGroup]="formColaborador">
        <div class="col-md-2 form-group">
          <label class="font-weight-semibold">Matrícula</label>

          <input
            type="text"
            class="form-control"
            placeholder="Matrícula"
            mask="0*"
            formControlName="matricula"
          />

          <span class="form-text" *ngIf="loading"
            >Carregando <i class="fa fa-spinner fa-spin" aria-hidden="false"></i
          ></span>
        </div>

        <div class="col-md-10 form-group">
          <label class="font-weight-semibold">Nome do Colaborador</label>
          <input type="text" class="form-control" placeholder="Nome" formControlName="nome" />
        </div>
      </form>
    </div>
  </div>
  <div class="card">
    <div class="card-header">
      <div class="d-flex justify-content-between">
        <h3 class="card-title font-weight-semibold">Lista de Comissões</h3>
        <div>
          <button type="button" class="btn btn-outline-primary" (click)="downloadPdf()">
            <i class="bi bi-download"></i> Download
          </button>
          <button
            type="button"
            class="btn btn-outline-primary ml-3"
            data-toggle="modal"
            data-target="#modalComissao"
            (click)="adicionarComissao()"
          >
            <i class="fa fa-plus mr-1" aria-hidden="true"></i>
            <span> Adicionar Comissão </span>
          </button>
        </div>
      </div>
    </div>
    <div class="card-body table-responsive mt-2">
      <table
        *ngIf="listaComissao.length > 0; else listaVazia"
        class="table table-striped border-blue text-center mt-2"
      >
        <thead class="bg-teal-400">
          <tr>
            <th>Nº Processo</th>
            <th>Motivo</th>
            <th>Data Início</th>
            <th>Data Fim</th>
            <th>Ações</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let comissao of listaComissao">
            <td>{{ comissao.NumeroProcesso }}</td>
            <td>{{ comissao.Motivo }}</td>
            <td>{{ comissao.DataInicio.ToDate }}</td>
            <td>{{ comissao.DataFim.ToDate }}</td>
            <td class="d-flex justify-content-center">
              <button
                type="button"
                class="btn btn-outline-primary mr-2"
                data-toggle="modal"
                data-target="#modalComissao"
                (click)="editarComissao(comissao)"
              >
                <i class="fa fa-pencil"></i>
              </button>
              <button
                type="button"
                [ngClass]="{
                  'btn-outline-primary': comissao.Obs === 'N',
                  'btn-primary': comissao.Obs === 'S'
                }"
                class="btn mr-2"
                data-toggle="modal"
                data-target="#observacoesLicencaPremioModal"
                (click)="modalObservacoes.abrirModal(comissao)"
              >
                <i class="fa-solid fa-book fa-lg"></i>
              </button>
              <button
                type="button"
                [ngClass]="{
                  'btn-outline-primary': comissao.Documento === 'N',
                  'btn-primary': comissao.Documento === 'S'
                }"
                class="btn mr-2"
                data-toggle="modal"
                data-target="#anexoComissaoModal"
                (click)="modalAnexo.abrirModal(comissao)"
              >
                <i class="fa fa-file"></i>
              </button>
              <button
                type="button"
                class="btn btn-outline-danger"
                (click)="excluirComissao(comissao)"
              >
                <i class="fa fa-trash"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
      <ng-template #listaVazia>
        <div class="p-4 d-flex justify-content-center align-items-center">
          <h6 class="font-weight-semibold">Não há dados de comissão para esse colaborador.</h6>
        </div>
      </ng-template>
    </div>
  </div>
</section>
<!-- modal -->
<div class="modal fade" id="modalComissao" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <app-comissao-cadastro
        [cadastro]="cadastro"
        [numOrd]="numeroDeOrdem"
        [comissaoSelecionada]="comissaoSelecionada"
      ></app-comissao-cadastro>
    </div>
  </div>
</div>
<div class="modal fade" id="observacoesLicencaPremioModal" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <app-observacoes-ficha-funcional
        (gatilhoAtivado)="buscarListaComissao()"
        [colaborador]="colaborador"
        [tipo]="tipoPagina"
      >
      </app-observacoes-ficha-funcional>
    </div>
  </div>
</div>
<div class="modal fade" id="anexoComissaoModal" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <app-anexo
        (gatilhoAtivado)="buscarListaComissao()"
        [pagina]="tipoPagina"
        [matricula]="colaborador?.Matricula"
        [enviarSeparadamente]="true"
        [modal]="true"
      ></app-anexo>
    </div>
  </div>
</div>
